import React, { useEffect, useState } from 'react';

export const PAGE_SIZE = 50;

// Client-side paging for long admin lists (thousands of agents) so the page never renders them all at once.
export const usePaged = (items, resetKey, pageSize = PAGE_SIZE) => {
  const [page, setPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  useEffect(() => { setPage(1); }, [resetKey, items.length]);
  const current = Math.min(page, pageCount);
  return {
    pageItems: items.slice((current - 1) * pageSize, current * pageSize),
    page: current,
    pageCount,
    pageSize,
    total: items.length,
    setPage
  };
};

const Pagination = ({ page, pageCount, pageSize, total, setPage }) => {
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const button = 'px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed';
  return (
    <nav aria-label="Pagination" className="flex flex-wrap items-center justify-between gap-3 py-3">
      <p className="text-sm text-gray-600">Showing {from.toLocaleString()}–{to.toLocaleString()} of {total.toLocaleString()}</p>
      <div className="flex items-center gap-2">
        <button type="button" className={button} onClick={() => setPage(1)} disabled={page === 1}>First</button>
        <button type="button" className={button} onClick={() => setPage(page - 1)} disabled={page === 1}>Previous</button>
        <span className="text-sm text-gray-600 px-1">Page {page} of {pageCount}</span>
        <button type="button" className={button} onClick={() => setPage(page + 1)} disabled={page === pageCount}>Next</button>
        <button type="button" className={button} onClick={() => setPage(pageCount)} disabled={page === pageCount}>Last</button>
      </div>
    </nav>
  );
};

export default Pagination;
